import { render, staticRenderFns } from "./prowerSetting.vue?vue&type=template&id=18514ac8&"
import script from "./prowerSetting.vue?vue&type=script&lang=js&"
export * from "./prowerSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports